module.exports = __webpack_public_path__ + "img/section3_7.445674fa.png";